import { getMyUserAccounts, updateAccount } from '@wix/ambassador-identity-account-v2-account/http'

import { withMonitoring } from '../../monitoring/withMonitoring'
import { ambassadorHttpClient } from '../httpClient'

export const saveAgencyName = async (accountName: string) => {
  const getRequest = getMyUserAccounts({})
  const getResponse = await withMonitoring(() => ambassadorHttpClient.request(getRequest), 'getMyUserAccounts')

  // TODO: check if this is the right way to get accountId
  // This destructuring will throw if `accounts` is undefined or empty
  const [{ accountId }] = getResponse.data.accounts || []
  if (!accountId) {
    throw new Error('no accountId')
  }

  const updateRequest = updateAccount({ accountId, accountName })
  await withMonitoring(() => ambassadorHttpClient.request(updateRequest), 'updateAccount')
}
